export default "__VITE_ASSET__7tvMac4g__"